<template>
  <div :id="content.anchor" class="custom-title" :style="getStyle()" v-if="content" v-editable="content">
    <component class="title" :is="content.level || 'h2'" v-html="content.title"></component>
    <underline v-if="content.under && content.under.length > 0" :content="content.under[0]"></underline>
  </div>
</template>

<script>
export default {
  props: {
    content: {
      type: Object,
      default: null,
    },
  },
  methods: {
    getStyle() {
      return {
        textAlign: this.content.align || "center",
        padding: `${this.content.padding}px 0` || "20px 0",
        fontFamily: this.content.font_family && this.content.font_family != ' ' ? this.content.font_family : 'Luckiest Guy, cursive'
      };
    },
  },
};
</script>


<style lang="scss">
.title {
  color: $titleColor;
  padding: 1.5em;
  padding-bottom: 0.5em;
  font-size: nth($titleSize, 1);
  z-index: 1;
  .icon {
    margin-right: 15px;
  }
}
@media screen and (max-width: 980px) {
  .title {
    font-size: nth($titleSize, 2);
  }
}
</style>
